import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpContextToken,
} from '@angular/common/http';
import { defer, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../providers/spinner/spinner.service';

/** Passer ce token à true dans le HttpContext pour ne pas déclencher la barre de chargement (utile pour les requêtes en masse). */
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_SPINNER)) {
      return next.handle(req);
    }

    return defer(() => {
      this.spinnerService.show();
      return next.handle(req);
    }).pipe(
      finalize(() => {
        this.spinnerService.hide();
      })
    );
  }
}
